// extracted by mini-css-extract-plugin
export default {"container":"styles_container__gQusS","title":"styles_title__kPFk1"};